export default "__VITE_ASSET__D9r_q8a2__"